// extracted by mini-css-extract-plugin
export default {"titleContainer":"Oes_6"};